import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardProvidersExternalComponent } from './dashboard-providers-external.component';
import { DashboardProvidersRoutingModule } from './dashboard-providers-external-routing.module';
import { DashboardProvidersModule } from '../dashboard-providers/dashboard-providers.module';
import { ProvDashboardComponent } from './prov-dashboard/prov-dashboard.component';


@NgModule({
  imports: [
    CommonModule,
    DashboardProvidersRoutingModule,
    DashboardProvidersModule,
  ],
  declarations: [DashboardProvidersExternalComponent, ProvDashboardComponent]
})
export class DashboardProvidersExternalModule { }



// WEBPACK FOOTER //
// ./src/app/pages/dashboard-providers-external/dashboard-providers-external.module.ts